import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';

const About = () => {
  useReveal();

  return (
    <>
      <section className="page-hero">
        <h1>About Us</h1>
      </section>

      <section className="vision-mission">
        <div className="vm-container">
          <div className="vm-visual">
            <img src="/images/about/1.png" alt="Our Vision & Mission" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />
          </div>
          <div className="vm-content fade-in">
            <h2>Our Vision &amp; Mission</h2>
            <div className="vm-item">
              <h3>Our Vision</h3>
              <p>
                Our Vision Is To Make Financial Freedom Achievable For Every Family.
                We Aim To Protect People From EMI Traps, Scams, And Poor Financial
                Decisions.
              </p>
            </div>
            <div className="vm-item">
              <h3>Our Mission</h3>
              <p>
                Our Mission is to empower 10 lakhs families to reach ₹5 Crore in wealth freedom
                freedom, driven by early financial planning, disciplined investing, and a commitment to building generational financial stability.  
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="advisor-section">
        <div className="advisor-container">
          <div className="advisor-content fade-in">
            <h2>Advisor Expertise &amp; Philosophy</h2>
            <p className="subtitle">
              Led By <strong>Meenatshi Sankaran</strong>, MBA Finance And AMFI
              Registered Mutual Fund Distributor.
            </p>
            <ul className="philosophy-list">
              <li>Backed By A Legacy Of Experience From 1985 To Present.</li>
              <li>We Believe Money Without Purpose Is Financial Risk.</li>
              <li>Every Rupee Must Have A Destination.</li>
              <li>We Guide Clients To Own Their Money—And Their Reasons.</li>
            </ul>
          </div>
          <div className="advisor-visual">
            <div className="decorative-blocks">
              {/* <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div> */}

            <img src="/images/about/2.png" alt="Our Vision & Mission" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />

            </div>


          </div>
        </div>
      </section>

      <section className="need-help">
        <div className="help-container">
          <div className="help-visual">
            <div className="decorative-blocks">
              {/* <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div>
              <div className="block"></div> */}
            <img src="/images/about/3.png" alt="Our Vision & Mission" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />

            </div>
          </div>
          <div className="help-content fade-in">
            <h2>"Need Help?"</h2>
            <h3>Confused About SIPs, Mutual Funds, Or Retirement Planning?</h3>
            <p>Professional Guidance Simplifies Complex Financial Decisions. We Listen, Assess, And Then Advise.</p>
            <Link to="/contact" className="cta-button">Speak with a Financial Advisor</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
